import React, { useState, useEffect } from "react";
import { Container, Row, Col } from "reactstrap";
import * as url from "../../utils/urls";
import { apiReq } from "../../utils/utils";
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import Swal from "sweetalert2";
import Loading from "../../components/Common/Loading";

function Stats(props) {
  const [stats, setStats] = useState([
    {
      value: "",
      desc: "",
    },
  ]);
  const [isEmpty, setIsEmpty] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const {
    register,
    handleSubmit,
    watch,
    setValue,
    formState: { errors },
  } = useForm();
  const allFields = watch();
  const user = useSelector((state) => state.User);
  useEffect(() => {
    if (user?.user?.role?.title !== "Admin") {
      props.history.push("/dashboard");
    }
  }, []);

  // console.log("user", user);

  // get Stats
  const getStats = () => {
    setIsLoading(true);
    apiReq(url.GET_STATS, {}, "get", null)
      .then((res) => {
        console.log("stats>>>", res);
        if (res.success && res.data !== null) {
          setValue("title", res.data.title);
          setValue("description", res.data.description);
          setStats(res.data.stats);
          setIsEmpty(false);
          setIsLoading(false);
        } else {
          setIsEmpty(true);
          setIsLoading(false);
        }
      })
      .catch((err) => {
        setIsLoading(false);
        console.log("err>>>", err);
      });
  };

  useEffect(() => {
    getStats();
  }, []);

  // Todo: Create stats
  const createStats = (data) => {
    if (isEmpty) {
      setIsLoading(true);
      apiReq(
        url.CREATE_STATS,
        {
          title: data.title,
          description: data.description,
          stats: stats,
        },
        "post",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    } else {
      setIsLoading(true);
      apiReq(
        url.UPDATE_STATS,
        {
          title: data.title,
          description: data.description,
          stats: stats,
        },
        "put",
        {
          Authorization: `Bearer ${user.user?.token}`,
        }
      )
        .then((res) => {
          setIsEmpty(false);
          setIsLoading(false);
          Swal.fire({
            title: "Success",
            text: res.message,
            icon: "success",
            showConfirmButton: false,
            timer: 1500,
          });
          // console.log("res>>>", res);
        })
        .catch((err) => {
          setIsLoading(false);
          console.log("err>>>", err);
        });
    }
  };

  //Todo: addNewStats
  const addNewStats = () => {
    setStats([...stats, { value: "", desc: "" }]);
  };

  // Todo: removeStats
  const removeStats = (index) => {
    const newStats = [...stats];
    newStats.splice(index, 1);
    setStats(newStats);
  };

  // Todo: handleStats
  const handleStats = (e, index) => {
    const { name, value } = e.target;
    const newStats = [...stats];
    newStats[index][name] = value;
    setStats(newStats);
  };

  // console.log("stats>>>", stats);

  return (
    <React.Fragment>
      <div className="page-content">
        {isLoading && <Loading />}
        <Container fluid>
          <div className="card">
            <div className="card-body">
              <h5 className="card-title">Stats</h5>
              <hr />
              <form onSubmit={handleSubmit(createStats)}>
                <div className="mt-4">
                  <div className="mb-3">
                    <label>
                      Title{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.title?.length} / 80)
                      </small>
                    </label>
                    <input
                      type="text"
                      className="form-control"
                      {...register("title", { required: true })}
                      placeholder="Enter title"
                    />
                    {errors.title && (
                      <span className="text-danger">Title is required</span>
                    )}
                  </div>
                  <div className="mb-3">
                    <label>
                      Description{" "}
                      <small className="text-muted" style={{ opacity: 0.5 }}>
                        ({allFields?.description?.length} / 170)
                      </small>
                    </label>
                    <textarea
                      className="form-control"
                      placeholder="Enter description"
                      {...register("description", { required: true })}
                      style={{ resize: "none", minHeight: "130px" }}
                    ></textarea>
                    {errors.description && (
                      <span className="text-danger">
                        Description is required
                      </span>
                    )}
                  </div>
                  <div className="mt-3">
                    <label>Stats</label>
                    <hr />
                    {stats.length > 0 && (
                      <div>
                        {stats.map((stat, index) => {
                          return (
                            <div key={index} className="row mb-4">
                              <div className="col-md-11">
                                <div className="mb-2">
                                  <input
                                    type="text"
                                    placeholder="Vaue"
                                    className="form-control"
                                    value={stat.value}
                                    name="value"
                                    onChange={(e) => handleStats(e, index)}
                                  />
                                </div>
                                <div className="mb-0">
                                  <input
                                    type="text"
                                    placeholder="Description"
                                    value={stat.desc}
                                    className="form-control"
                                    name="desc"
                                    onChange={(e) => handleStats(e, index)}
                                  />
                                </div>
                              </div>
                              <div className="col-md-1">
                                <button
                                  className="btn btn-danger"
                                  style={{ width: "100%" }}
                                  type="button"
                                  onClick={() => removeStats(index)}
                                >
                                  <i className="ri-delete-bin-line"></i>
                                </button>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    )}
                    <hr />
                    <div className="d-flex justify-content-end">
                      <button
                        className="btn btn-success"
                        onClick={addNewStats}
                        type="button"
                      >
                        <i className="ri-add-fill"></i> Add Stat
                      </button>
                    </div>
                  </div>
                </div>
                <hr />
                <div>
                  <button className="btn btn-primary" type="submit">
                    Save changes
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Container>
      </div>
    </React.Fragment>
  );
}

export default Stats;
